__turbopack_context__.v({
  "expandableCopy": "niSc6a_expandableCopy",
  "propertyDescription": "niSc6a_propertyDescription",
  "propertyDescriptionContentOverlay": "niSc6a_propertyDescriptionContentOverlay",
});
